import React from 'react';

import displayName from 'component-lib/displayName';
import styles from './Forms.scss';

export default function HelpIcon() {
    return (
        <span>
            <span data-tip data-for="help-icon" className={styles['help-icon']} />
        </span>
    );
}

HelpIcon.displayName = displayName('Forms/HelpIcon');
